import { defaultTheme } from "@geberit/gdds"
import dynamic from "next/dynamic"
import { ThemeProvider as GeberitThemeProvider } from "styled-components"

const Carousel = dynamic(
  async () => {
    const mod = await import("@geberit/gdds")
    return mod.Carousel
  },
  { ssr: false }
)

export const GeberitCarousel = (props) => {
  return (
    <GeberitThemeProvider theme={defaultTheme}>
      <Carousel supportMouse hideButtons hideButtonsTablet autoSnap {...props}>
        {props.children}
      </Carousel>
    </GeberitThemeProvider>
  )
}

export default GeberitCarousel
